module.exports = __webpack_public_path__ + "assets/img/page-title-59aa316f.png";